import React from 'react'
import styles from './Style.module.css'

const ToggleSwitch = ({name, checked, handleChange, ariaLabel}) => {
  return (
    <label className={styles.switch}>
        <input 
          type="checkbox" 
          name={name}
          checked={Boolean(checked)}
          aria-label={ariaLabel}
          onChange={(e) => handleChange(e.target.checked)}
        />
        <span className={styles.slider}></span>
    </label>
  )
}

export default ToggleSwitch
